"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Balancer = void 0;
const adapter_1 = __importDefault(require("./adapter"));
const BALANCER_ABI = require("../../abi/balancer.json");
class Balancer extends adapter_1.default {
    static getDexData(optimalRate, name) {
        return {
            name,
            srcAmount: optimalRate.srcAmount,
            destAmount: '1',
            exchangeProxy: optimalRate.data.exchangeProxy,
            swaps: optimalRate.data.swaps.map((s) => ({
                pool: s.pool,
                tokenInParam: s.tokenInParam,
                tokenOutParam: s.tokenOutParam,
                maxPrice: s.maxPrice
            })),
        };
    }
    getFillMethod(srcToken, destToken, data) {
        const contract = new this.web3Provider.eth.Contract(BALANCER_ABI, data.exchangeProxy);
        if (this.isETHAddress(srcToken)) {
            return contract.methods.batchEthInSwapExactIn(data.swaps, destToken, data.destAmount).encodeABI();
        }
        else if (this.isETHAddress(destToken)) {
            return contract.methods.batchEthOutSwapExactIn(data.swaps, srcToken, data.srcAmount, data.destAmount).encodeABI();
        }
        else {
            return contract.methods.batchSwapExactIn(data.swaps, srcToken, destToken, data.srcAmount, data.destAmount).encodeABI();
        }
    }
    buildSwap(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const swapData = this.getFillMethod(srcToken, destToken, data);
            return this.swap(srcToken, destToken, data, swapData, data.exchangeProxy);
        });
    }
}
exports.Balancer = Balancer;
//# sourceMappingURL=balancer.js.map